module.exports = __webpack_public_path__ + "img/icon-school-group.9b4bd0c0.png";